__webpack_require__.p = "/Pratica-Components/";